// The plan screen: the app's signage (MemberPitch — the 200+ barns, the barns
// selling now, everything a Member gets) around the plan card, monthly or
// yearly, one tap to Stripe's checkout. The picker is the account page's own
// (SiteBilling), so every door offers the same thing.
//
// Two doors use it: the wall when the free month has ended (RequireAccount's
// PlanWall) and /subscribe, where every Subscribe link goes (2026-11-04).

import { siteHomeHref } from "@/lib/siteHost";

import { TickerShell } from "../cattle-ticker/TickerShell";
import MemberPitch from "./MemberPitch";
import SiteBilling from "./SiteBilling";

export function PlanCard({ eyebrow, title }: { eyebrow: string; title: string }) {
  return (
    <TickerShell crumbs={[{ label: "Home", href: "/" }, { label: "Subscribe" }]}>
      <div className="rbacct">
        <MemberPitch>
          <div className="rbacct-card" data-wall="plans">
            <p className="rbacct-eyebrow">{eyebrow}</p>
            <h1 className="rbacct-title">{title}</h1>
            <SiteBilling onWall />
            <p className="rbacct-fine">The homepage and Boxed Beef stay free. <a href={siteHomeHref()}>Back to today&rsquo;s prices</a></p>
          </div>
        </MemberPitch>
      </div>
    </TickerShell>
  );
}
